import {PAGE_UPDATED} from "./types";

export const updatePage = (title, hideTitle = false, supportId = null) => dispatch => {
    dispatch({ type: PAGE_UPDATED, payload: { title: title, hideTitle: hideTitle, supportId: supportId } });
};